import * as actionTypes from './actionTypes';

export const storeCampaignName = (payload) => ({ type: actionTypes.CAMPAIGN_SET_NAME_REQUEST, name: payload });
export const setCampaignNameUpdate = (payload) => ({ type: actionTypes.CAMPAIGN_SET_NAME_UPDATE, name: payload });

export const storeTargetIntegrations = (payload) => ({ type: actionTypes.CAMPAIGN_ENABLE_INTEGRATION_REQUEST, payload });
export const setTargetIntegrationsUpdate = (payload) => ({ type: actionTypes.CAMPAIGN_ENABLE_INTEGRATION_UPDATE, payload });

export const createCampaignRequest = () => ({ type: actionTypes.CAMPAIGN_CREATE_REQUEST });
export const createCampaignError = (payload) => ({ type: actionTypes.CAMPAIGN_CREATE_ERROR, payload });
export const createCampaignStore = (payload) => ({ type: actionTypes.CAMPAIGN_CREATE_SUCCESS, payload });

export const removeCampaignRequest = (payload) => ({ type: actionTypes.CAMPAIGN_REMOVE_REQUEST, payload });
export const removeCampaignError = (payload) => ({ type: actionTypes.CAMPAIGN_REMOVE_ERROR, payload });
export const removeCampaignSuccess = (payload) => ({ type: actionTypes.CAMPAIGN_REMOVE_SUCCESS, payload });

export const publishCampaignRequest = (payload) => ({ type: actionTypes.CAMPAIGN_PUBLISH_REQUEST, payload });
export const publishCampaignError = (payload) => ({ type: actionTypes.CAMPAIGN_PUBLISH_ERROR, payload });
export const publishCampaignStore = (payload) => ({ type: actionTypes.CAMPAIGN_PUBLISH_SUCCESS, payload });

export const campaignResetRequest = () => ({ type: actionTypes.CAMPAIGN_RESET_REQUEST });
export const resetCampaignState = () => ({ type: actionTypes.CAMPAIGN_RESET_STATE });
